import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import {trigger, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'dp-modal-box',
    templateUrl: './modal-box.component.html',
    styleUrls: ['./modal-box.component.scss'],
    animations: [    trigger('fade', [ 
        transition('void => *', [
         style({ opacity: 0 }), 
         animate(2000, style({opacity: 1}))
       ]) 
     ])]
})
export class ModalBoxComponent implements AfterViewInit {
    @Input() public title = '';
    @Input() public show = false;
    @Input() public canClose = true;
    @Input() public canGoBack = false;
    @Output() public onclose = new EventEmitter();
    @Output() public onback = new EventEmitter();

    private bodyClassName = 'modal-open';

    public ngAfterViewInit() {
        if (this.show) {
            this.open();
        }
    }

    public toggle() {
        this.show ? this.close() : this.open();
    }

    public open() {
        this.show = true;
        this.toggleBodyClass();
    }

    public close() {
        this.show = false;
        this.toggleBodyClass();
        this.onclose.emit();
    }

    public back() {
        this.onback.emit();
        this.close();
    }

    private toggleBodyClass() {
        const body = document.querySelector('body');

        if (this.show) {
            body.classList.add(this.bodyClassName);
        } else {
            body.classList.remove(this.bodyClassName);
        }
    }
}
